__turbopack_context__.v({
  "active": "MobileFilter-module-scss-module__gxb3iW__active",
  "filterLinks": "MobileFilter-module-scss-module__gxb3iW__filterLinks",
  "mobileFilter_layout": "MobileFilter-module-scss-module__gxb3iW__mobileFilter_layout",
});
